import { defineStore } from 'pinia'

/**
 * Estado compartilhado do canal de suporte (Chatwoot).
 *
 * Existe porque o launcher do suporte (ChatSupport.vue, global no App.vue)
 * e a bolha do changelog (Changelog.vue, dentro de uma view) ocupam o mesmo
 * canto inferior direito, mas nao tem relacao de parentesco no template —
 * entao precisam de um canal desacoplado pra nao se sobrepor.
 */
export const useChatSupportStore = defineStore('chatSupport', {
    state: () => {
        return {
            // true so quando o launcher do suporte esta de fato visivel
            // (logado + SDK pronto + dominio liberado). Quem consome usa
            // isso pra se deslocar e ficar AO LADO, nao por cima.
            launcherVisible: false
        }
    },
    actions: {
        setLauncherVisible(visible) {
            this.launcherVisible = visible
        }
    }
})
